import type React from "react";
function OpenInViewerIcon({ onClick }: { onClick?: React.MouseEventHandler<SVGSVGElement> }) {
  return (
    <svg
      style={{ cursor: "pointer" }}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00003 8.871L12.09 5.781V4.719L8.87253 1.5L7.81203 2.5605L7.87653 2.625L8.25153 3L9.75153 4.5H5.25153C4.25696 4.5 3.30314 4.89509 2.59988 5.59835C1.89661 6.30161 1.50153 7.25544 1.50153 8.25C1.50153 9.24456 1.89661 10.1984 2.59988 10.9017C3.30314 11.6049 4.25696 12 5.25153 12H6.00003V10.5H5.25003C4.95455 10.5 4.66197 10.4418 4.38899 10.3287C4.11601 10.2157 3.86797 10.0499 3.65904 9.84099C3.4501 9.63206 3.28437 9.38402 3.1713 9.11104C3.05822 8.83806 3.00003 8.54547 3.00003 8.25C3.00003 7.95453 3.05822 7.66194 3.1713 7.38896C3.28437 7.11598 3.4501 6.86794 3.65904 6.65901C3.86797 6.45008 4.11601 6.28434 4.38899 6.17127C4.66197 6.0582 4.95455 6 5.25003 6H9.75003L7.81053 7.9395L8.87103 9L9.00003 8.871ZM16.5 3H12.492L10.992 1.5H18L19.065 1.935L23.565 6.435L24 7.5V21L22.5 22.5H9.00003L7.50003 21V9.75L9.00003 11.0205V21H22.5V9H16.5V3ZM18 3V7.5H22.5L18 3Z"
        fill="black"
      />
    </svg>
  );
}

export default OpenInViewerIcon;
